/**
 * Centralised registry of every localStorage key used by the app.
 *
 * Any new key MUST be added here; ad-hoc `localStorage.*` calls are
 * forbidden and lint-enforced (see eslint.config.mjs).
 */
export const STORAGE_KEYS = {
  authConfigs: 'workflow_builder_auth_configs',
  activeAuthConfig: 'workflow_builder_active_config',
  workflowCachePrefix: 'workflow_cache_',
} as const;

export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];
